<template>
  <div
    v-if="visible"
    class="ka-tt"
    :class="{ 'ka-tt--docked': docked }"
    :style="positionStyle"
  >
    <div class="ka-tt-date">{{ date }}</div>
    <div v-if="rows.length > 1" class="ka-tt-rows" :class="{ 'ka-tt-rows--wrap': docked }">
      <span
        v-for="(r, i) in rows"
        :key="i"
        class="ka-tt-row"
      >
        <span class="ka-tt-dot" :style="{ background: r.color }"></span>
        <span class="ka-tt-label">{{ r.label }}</span>
        <span class="ka-tt-price">{{ r.price }}</span>
        <span class="ka-tt-pct" :class="r.pctVal >= 0 ? 'positive' : 'negative'">{{ r.pct }}</span>
      </span>
    </div>
    <div v-else-if="rows.length === 1" class="ka-tt-single">
      <span class="ka-tt-price">{{ rows[0].price }}</span>
      <span class="ka-tt-pct" :class="rows[0].pctVal >= 0 ? 'positive' : 'negative'">{{ rows[0].pct }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartTooltip',
  props: {
    visible: { type: Boolean, default: false },
    date: { type: String, default: '' },
    rows: { type: Array, default: () => [] },
    left: { type: Number, default: 0 },
    top: { type: Number, default: 0 },
    docked: { type: Boolean, default: false }
  },
  computed: {
    positionStyle() {
      if (this.docked) return {};
      return { left: this.left + 'px', top: this.top + 'px' };
    }
  }
}
</script>

<style>
.ka-tt {
  position: absolute;
  pointer-events: none;
  z-index: 20;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.10);
  padding: 8px 12px;
  white-space: nowrap;
  font-family: Inter, -apple-system, BlinkMacSystemFont, sans-serif;
}

.ka-tt--docked {
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  padding: 4px 7px;
  white-space: normal;
}

.ka-tt-date {
  font-size: 10px;
  color: #777;
  margin-bottom: 3px;
}

.ka-tt--docked .ka-tt-date {
  font-size: 7px;
  margin-bottom: 2px;
}

.ka-tt-rows {
  display: flex;
  flex-direction: column;
}

.ka-tt-rows--wrap {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1px 0;
}

.ka-tt-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 3px;
}

.ka-tt--docked .ka-tt-row {
  display: inline-flex;
  gap: 2px;
  margin-top: 0;
  margin-right: 6px;
}

.ka-tt-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ka-tt--docked .ka-tt-dot {
  width: 5px;
  height: 5px;
}

.ka-tt-label {
  font-size: 11px;
  font-weight: 600;
  color: #222;
  min-width: 40px;
}

.ka-tt--docked .ka-tt-label {
  font-size: 7px;
  min-width: 0;
}

.ka-tt-price {
  font-size: 11px;
  color: #555;
}

.ka-tt--docked .ka-tt-price {
  font-size: 7px;
}

.ka-tt-pct {
  font-size: 11px;
  font-weight: 600;
}

.ka-tt--docked .ka-tt-pct {
  font-size: 7px;
}

.ka-tt-pct.positive { color: #16A34A; }
.ka-tt-pct.negative { color: #DC2626; }

/* Single-metal row */
.ka-tt-single {
  display: flex;
  align-items: center;
  gap: 6px;
}

.ka-tt-single .ka-tt-price {
  font-size: 12px;
  font-weight: 600;
  color: #222;
}

.ka-tt-single .ka-tt-pct {
  font-size: 12px;
}

/* === Mobile overrides (non-docked) === */
.ka-pc--mobile .ka-tt:not(.ka-tt--docked) {
  padding: 4px 7px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-date {
  font-size: 8px;
  margin-bottom: 1px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-row {
  gap: 3px;
  margin-top: 1px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-dot {
  width: 5px;
  height: 5px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-label {
  font-size: 8px;
  min-width: 28px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-price {
  font-size: 8px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-pct {
  font-size: 8px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-single {
  gap: 4px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-single .ka-tt-price {
  font-size: 10px;
}

.ka-pc--mobile .ka-tt:not(.ka-tt--docked) .ka-tt-single .ka-tt-pct {
  font-size: 10px;
}
</style>
